const doc = [({"zh_tw":({"buttonActivity":({"addRoom":"增加經驗", "backToHotel":"返回體驗預約頁面", "backToRoomList":"返回體驗列表", "removeRoom":"刪除體驗", "roomDetail":"體驗詳情"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;